import { Avatar, Button, Col, DatePicker, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import axios from "axios";

import agencyProfile from "../../../../assets/pic.png";
import BadPhoneNumber from "../../../../assets/phone-number.png";
import { DATE_FORMAT, getNameInitials } from "../../../../utils/Constants";
import { useBoundStore } from "../../../../store/useBoundStore";
import { createNotificationUI } from "../../../../store/slices/NotificationSlice/notification_seen_unseen";

// const dateFormat = "MM.DD.YYYY";
const dateFormat = DATE_FORMAT;
const today = new Date();
const ButtonGroup = Button.Group;

function EaProfileFilter({
  collapsed,
  setState,
  state,
  loadStats,
  history,
  badPhoneNumberCount,
  with_appointments,
  unseen_notifications,
  ...rest
}) {

  const onChangeStat = (id = "") => {
    localStorage.setItem("user_t", id);
    localStorage.setItem('filter_lsp', id)
    setState({
      user_t: id,
      filter_lsp: id,
      internalFilterChange: false,
    });
  };

  const handleBadPhoneNumberFunc = () => {
    let datemodified = useBoundStore.getState().fSfilters.datemodified;
    const initialDateRange = {
      start_date: datemodified.start_date || "2010-01-01",
      end_date: datemodified.end_date || "2050-01-01",
    };
    useBoundStore.getState().setFsFilters({ datemodified: initialDateRange, searchText: "", page: 1, filter_by_column_name: {} })
    history.push(`/newbfiles/bad-phone-numbers?all_bfiles`);
  };


  return (
    <div className="">
      <div
        className="user_profile_detail width-100 userProfile-height"
        style={{ padding: "4px", position: "relative", minHeight: "155px" }}
      >
        <Row>
          <Col lg={24} span={24}>
            <div>
              <Row style={{ display: "flex", alignItems: "center" }}>
                {state && state.agency.agency_photo_url && state.agency.agency_photo_url !== null ? (<Avatar
                  style={{ margin: 20 }}
                  size={60}
                  src={state.agency.agency_photo_url || agencyProfile}
                />) : (
                  <span style={{
                    margin: 20,
                    color: "rgb(22, 72, 151)",
                    width: "60px",
                    height: "60px",
                    fontWeight: "600",
                    fontFamily: "Poppins",
                    fontSize: "28px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    background: "#F0F2F5",
                    padding: "15px"
                  }} >{getNameInitials(`${state.agency.name}`)}</span>
                )}
                <div className="agency_details">
                  <div className="agency_user_name text-20">
                    {state.user.first_name + " " + state.user.last_name}{" "}
                  </div>
                  <div>
                    <span style={{ fontSize: "smaller" }} className="text-14">
                      {state.user_type}
                    </span>
                  </div>
                  <div className="owner text-14">{state.agency.name}</div>
                </div>
              </Row>
            </div>
          </Col>
        </Row>

        <div className="padding-top-10 ">
          <Row gutter={[16, 16]} style={{ width: "100%" }}>

            {((state.review === 1 || state.vonboard === 1
              || state.show_lead_card_appointment_details === 1) && (
                <Col xs={24} sm={24} md={24} lg={with_appointments ? 12 : 7}>
                  <div>
                    <Button
                      shape="round"
                      type="default"
                      className="bad_phone_number"
                      onClick={handleBadPhoneNumberFunc}
                      style={{ width: "100%" }}
                    >
                      <img
                        src={BadPhoneNumber}
                        alt="Bad Phone Number"
                        width="16px"
                      />
                      <span className="text-11">Bad Phone Numbers</span>
                      <span className="text-11">{badPhoneNumberCount}</span>
                      {/* <span className="text-11"
                    onClick={() => {
                      if (unseen_notifications > 0) {
                        useBoundStore.getState().setNotificationSeenUnseen({
                          unseenNotifications: 0,
                        })
                      }
                    }}
                  >{unseen_notifications}</span> */}
                    </Button>
                  </div>
                </Col>
              )
            )}

            <Col xs={24} sm={24} md={24} lg={with_appointments ? 12 : 7}>
              <ButtonGroup
                className="button_selection_group"
                style={{ width: "100%" }}
              >
                <Button
                  className={`my_stat text-11 text-weight-500 stats-height ${state.filter_lsp ? "active" : ""
                    }`}
                  style={{ width: "50%" }}
                  onClick={() => onChangeStat(state.user.id)}
                >
                  My Stats
                </Button>
                <Button
                  className={`agency_stat text-11 text-weight-500 stats-height ${!state.filter_lsp ? "active" : ""
                    }`}
                  onClick={() => onChangeStat()}
                  style={{ width: "50%" }}
                >
                  Agency Stats
                </Button>

              </ButtonGroup>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default withRouter(EaProfileFilter);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/EA_And_LSP/EaProfileFilter.js